export const UserProfileApiUrls = {
  getCandidatesByUserId: "candidate/getCandidatesByUserId",
};

export default class UserProfileAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async getCandidatesByUserId(data, token) {
    return this.get(UserProfileApiUrls.getCandidatesByUserId, data, token);
  }

  async get(url, data, token) {
    return await this.httpsClient.get(url, data, token);
  }

  async post(url, data, token) {
    return await this.httpsClient.post(url, data, token);
  }
}
